import { Component, h, Prop } from '@stencil/core';

export type FooterMode = undefined | 'compact';

@Component({
    tag: 'lilu-footer',
    styleUrl: 'lilu-footer.scss',
    shadow: true
})
export class LiluFooter {
    @Prop() footerMode: FooterMode;

    render() {
        const isCompact = this.footerMode === 'compact';

        return (
            <footer>
                { !isCompact &&
                    <div class="row row-1">
                      <slot name="row-1"></slot>
                    </div>
                }
                <div class="row row-2">
                    <slot name="row-2"></slot>
                </div>
            </footer>
        );
    }
}
